// src/components/EmpresaBadge.jsx
import React from 'react';
import { normalizarEmpresa } from '../utils/empresaUtils';

/**
 * Componente de insignias de Empresa (BUNZL, B2B, VICSA, TB, DPS, etc.)
 */
export default function EmpresaBadge({ empresa, className = "" }) {
  if (!empresa || typeof empresa !== 'string' || !empresa.trim()) {
    return null;
  }

  const raw = normalizarEmpresa(empresa);
  const lower = raw.toLowerCase();

  let label = raw.toUpperCase();
  let colorStyle = "bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300 border-gray-200 dark:border-gray-700";

  if (lower === 'vicsa uruguay') {
    label = 'VICSA UY';
    colorStyle = "bg-orange-50 text-orange-700 dark:bg-orange-950/40 dark:text-orange-300 border-orange-200 dark:border-orange-800/50";
  } else if (lower.includes('bunzl')) {
    label = 'BUNZL';
    colorStyle = "bg-purple-50 text-purple-700 dark:bg-purple-950/40 dark:text-purple-300 border-purple-200 dark:border-purple-800/50";
  } else if (lower.includes('b2b')) {
    label = 'B2B';
    colorStyle = "bg-blue-50 text-blue-700 dark:bg-blue-950/40 dark:text-blue-300 border-blue-200 dark:border-blue-800/50";
  } else if (lower.includes('vicsa')) {
    label = 'VICSA';
    colorStyle = "bg-amber-50 text-amber-700 dark:bg-amber-950/40 dark:text-amber-300 border-amber-200 dark:border-amber-800/50";
  } else if (lower.includes('tecnoboga') || lower === 'tb') {
    label = 'TB';
    colorStyle = "bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300 border-emerald-200 dark:border-emerald-800/50";
  } else if (lower.includes('dps')) {
    label = 'DPS';
    colorStyle = "bg-cyan-50 text-cyan-700 dark:bg-cyan-950/40 dark:text-cyan-300 border-cyan-200 dark:border-cyan-800/50";
  }

  return (
    <span className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-bold tracking-wider uppercase border shadow-xs transition-colors ${colorStyle} ${className}`}>
      {label}
    </span>
  );
}
